import { FC } from "react";
import { SkeletonLoading } from "react-migration/components/SkeletonLoading";

export const LoadingPanel: FC = () => {
  return (
    <div className="relative h-80 bg-white border-8 border-white" data-testid="ownership-selection-header-loading">
      <SkeletonLoading rows={3} showPadding={false} />
    </div>
  );
};
